import makeSettingsReducer from 'app/common/reducers/settings/makeSettingsReducer';


const defaultState = {
  cartId: '',
};

export default makeSettingsReducer('shop', defaultState);
